import { Stack } from "@mui/material";
import { UseFormReturn } from "react-hook-form-mui";

import { GqlPermissions } from "~/__generated__";
import useHasTenantPermission from "~/modules/auth/hooks/useHasPermission";

import { ProtocolVisitFormInput } from "../ProtocolVisitsEditor/VisitEditForm";
import PrecipitationSlider from "./sliders/PrecipitationSlider";
import TemperatureRangeSlider from "./sliders/TemperatureRangeSlider";
import WindForceSlider from "./sliders/WindForceSlider";

type Props = {
    formContext: UseFormReturn<ProtocolVisitFormInput>;
};

export default function ProtocolVisitsWeatherEditor({ formContext }: Props) {
    const { control } = formContext;
    const isAdmin = useHasTenantPermission(GqlPermissions.Administrator);

    return (
        <Stack gap={2}>
            <TemperatureRangeSlider
                control={control}
                minName="minTemperature"
                maxName="maxTemperature"
                disabled={!isAdmin}
            />

            <WindForceSlider control={control} name="maxWindForce" disabled={!isAdmin} />

            <PrecipitationSlider control={control} name="maxPrecipitation" disabled={!isAdmin} />
        </Stack>
    );
}
